import React from 'react';

import UserListModal, { UserListModalProps } from "../users/UserListModal";

import { AnswerForMappingFragment, useGetUsersMinimal } from "../../graphql/generated/definitions";
import useTranslations from "../../hooks/useTranslations";

type AnalyticsQuestionUserModalProps = {
  answers: AnswerForMappingFragment[],
} | UserListModalProps;

const AnalyticsQuestionUserModal: React.FC<AnalyticsQuestionUserModalProps> = ({
  answers,
  ...props
}) => {
  const t = useTranslations();

  const { data, loading } = useGetUsersMinimal({
    variables: {
      idsStrict: answers.map(({ collaboratorId }) => collaboratorId)
    }
  });

  const users = data?.users?.collection || [];

  return (
    <UserListModal
      users={users}
      loading={loading}
      {...props}
    />
  );
}

export default React.memo(AnalyticsQuestionUserModal);
